<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">

      <el-form-item>
        <template slot="label">
          大頭照<br>(300x300)
        </template>
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="left"
          style="height: 180px;"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genImageFileParam())">
          <img
            ref="avatarImg"
            v-show="form['avatarObjectURL'] || form.ImageURL"
            @load="e => onImageLoaded(e, genImageFileParam())"
            class="preview"
            :src="form['avatarObjectURL'] || form.ImageURL"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form.ImageURL || form['avatarObjectURL'])" class="el-icon-upload"></i>
          <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="名稱(繁中)">
        <el-input v-model="form.NameTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Cn')" label="名稱(簡中)">
        <el-input v-model="form.NameCn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="名稱(英文)">
        <el-input v-model="form.NameEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="名稱(日文)">
        <el-input v-model="form.NameJp"></el-input>
      </el-form-item>

      <el-form-item label="簡介(繁中)">
        <el-input type="textarea" v-model="form.BriefTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Cn')" label="簡介(簡中)">
        <el-input type="textarea" v-model="form.BriefCn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="簡介(英文)">
        <el-input type="textarea" v-model="form.BriefEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="簡介(日文)">
        <el-input type="textarea" v-model="form.BriefJp"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
export default {
  mixins: [MixinProcessImageFile, MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        NameTw: '',
        NameCn: '',
        NameEn: '',
        NameJp: '',
        IsActive: true
      },
      mIsShow: false,
      isLoading: false,
      // image
      isProcessingImage: false,
      imgSrc: null
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.NameTw : '新增作者'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      let promise = this.isEdit
        ? this.$services.author.edit(this, this.form)
        : this.$services.author.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.author.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.author.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.author.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown author for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.NameTw) {
        errMsg = '請輸入繁中名稱'
      }
      if (this.languages.includes('Cn') && !this.form.NameCn) {
        errMsg = '請輸入簡中名稱'
      }
      if (this.languages.includes('En') && !this.form.NameEn) {
        errMsg = '請輸入英文名稱'
      }
      if (this.languages.includes('Jp') && !this.form.NameJp) {
        errMsg = '請輸入日文名稱'
      }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    genImageFileParam () {
      let requiredSize = { w: 300, h: 300 }
      // 當我們上傳圖片後，
      let params = {
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'elupload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'avatarImg',
        // 要上傳的表單 form
        'formObject': this.form,
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'avatarObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'ImageURL'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'avatarImageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `author/${this.form.ID}/avatar-`
            : `author/avatar-${this.form.NameTw}-`
        ]
      }
      return params
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            IsActive: true
          }
        }
      }
    }
  }
}
</script>
